import { Uuid } from 'src/interfaces'
import {
  Colegio,
  Comunidad,
  Datos,
  Orden,
  OrganoJudicial,
  Pais,
  PartidoJudicial,
  Provincia,
  TipoEscrito,
  TipoDocumentoIdentificativo,
  TipoIntervencion,
  TipoPersona,
  TipoRepresentacion,
  TipoTrasladoCopia,
  TipoVia,
  Municipio,
  TipoMensaje,
  Entidad,
  Resolucion,
  OrganismoExtrajudicial
} from 'src/interfaces/Catalog'

export interface LexonData {
  lexonId?: number
}

export interface TrasladoCopia extends Uuid {
  tipo?: TipoTrasladoCopia | null
  comunidad?: Comunidad | null
  provincia?: Provincia | null
  colegio: Colegio | null
  nif?: string
  codigoColegiado?: string
  nombre?: string
  primerApellido?: string
  segundoApellido?: string
  email?: string
  index?: number
}

export interface TipoDocumento {
  codigo: string
  descripcion?: string
  hashCode?: string
  id: number
}

export interface SubTipoDocumento extends TipoDocumento {
  activo?: boolean
  ordenes?: []
  tipoDocumento?: TipoDocumento
  tipoMensajes?: []
}

export interface DocumentoPrincipalType {
  archivo: string | null
  subtipo: SubTipoDocumento | string | null
  descripcion: string | null
  pendienteCompletar: boolean
  hash: string | null
  sign: boolean
}
export interface DocumentoAnexoType {
  archivo: string | null
  subtipo?: SubTipoDocumento | string | null
  descripcion?: string | null
  hash?: string | null
}

export interface FileHashType {
  file: File
  hash: string | null
}
export interface DocumentDb {
  IdDocumento: number | null
  IdSupraDocumento?: number
  IdExpedienteEtapa?: number
  idStage?: number
  Fecha: string
  FechaActualizacion?: string
  Nombre?: string
  Descripcion?: string
  IdTipoDoc?: string
  Ruta?: string
  Archivo?: string
  NumeroDocumento?: string
  ArchivoInicial?: string
  Principal?: boolean
  GDriveIdDocument?: string
  GDriveTipo?: string
  ODriveIdDocument?: string
  ODriveTipo?: string
  Publico?: string
  IdUser?: number
  IdCategory?: number
  StartEffectiveDate?: string
  EndEffectiveDate?: string
  IsEffect?: boolean
  Version?: string
  Path?: string
  IdEntityType?: number
  IdEntity?: number
  IdStatus?: number
  idUsersPermissions?: []
  tags?: []
}

export interface Direccion {
  sinNumero: boolean
  numero: string
  bloque?: string
  escalera?: string
  piso?: string
  km?: string
  letra?: string
  pais: Pais | null
  nombreVia: string
  tipoVia: TipoVia | null
  provincia?: Provincia | null
  codigoPostal?: string | null
  municipio?: Municipio | null
  ciudadLocalidad?: string
  informacionComplementaria?: string
}

export interface IntervenerDireccion {
  pais: Pais | null
  tipoVia: TipoVia | null
  provincia: Provincia | null
  municipio: Municipio | null
}

export const emptyDireccion: Direccion = {
  sinNumero: false,
  numero: '',
  bloque: '',
  escalera: '',
  piso: '',
  letra: '',
  km: '',
  pais: null,
  nombreVia: '',
  tipoVia: null,
  provincia: null,
  municipio: null,
  codigoPostal: '',
  ciudadLocalidad: '',
  informacionComplementaria: ''
}

export interface RepresentanteProcesal {
  comunidadAutonoma?: Comunidad | null
  provincia?: Provincia | null
  representacionTipo?: TipoRepresentacion | null
  codigoColegiado?: string
  nif?: string
  nombre?: string
  primerApellido?: string
  segundoApellido?: string
  email?: string
  colegio?: Colegio | null
  entidad?: Entidad | null
  remitente?: boolean
}

export interface RepresentanteLegal extends Uuid {
  personaTipo?: TipoPersona | null
  identificacionTipo: TipoDocumentoIdentificativo | null
  identificacion: string
  nombre?: string
  primerApellido?: string
  segundoApellido?: string
  direccion?: Direccion
}
export interface Sexo {
  codigo: string
  descripcion: string
}

export enum CuentaBancariaTipo {
  IBAN = 1,
  SWIFT = 2
}

export interface Interviniente extends LexonData, Uuid {
  personaTipo: TipoPersona | null
  intervencionTipo: TipoIntervencion | null
  identificacionTipo: TipoDocumentoIdentificativo | null
  identificacion?: string
  nombre: string
  primerApellido: string
  segundoApellido?: string
  sexo?: Sexo | null
  telefono?: string
  email?: string
  fechaNacimiento?: Date | null
  lugarNacimiento: string
  paisNacimiento: Pais | null
  nacionalidad: Pais | null
  nombrePadre?: string
  nombreMadre?: string
  direccion?: Direccion
  representantesLegales: RepresentanteLegal[]
  representantesProcesales: RepresentanteProcesal[]
  profesionalRepresentanteProcesal: boolean
  noIntervieneOtroProfesional?: boolean
  validated?: boolean
  cuentaBancariaTitular?: string
  cuentaBancariaNIF?: string
  cuentaBancariaNumeroCuenta?: string
  cuentaBancariaTipo?: CuentaBancariaTipo
}

export interface Destino {
  orden: Orden | null
  organo: OrganoJudicial | null
  partido: PartidoJudicial | null
  comunidad: Comunidad | null
  provincia: Provincia | null
  juzgadoGuardia: boolean
}

export interface Origen {
  orden: Orden | null
  organo: OrganoJudicial | null
  partido: PartidoJudicial | null
  comunidad: Comunidad | null
  provincia: Provincia | null
}

export interface OrganismoOrigen {
  organismoOrigen: OrganismoExtrajudicial | null
  numeroExpediente: string
  yearExpediente: string
}
export interface Nig {
  value: string
  N1: string
  N2: string
  N3: string
  N4: string
  N5: string
}
export interface Escrito {
  NIG: Nig
  cautelar: boolean
  datos: Datos
  descripcion: string
  destino: Destino | null
  documentoPrincipal: DocumentoPrincipalType[]
  documentoPrincipalArchivo: File | null
  documentosAnexos?: DocumentoAnexoType[]
  esCorreccion: boolean
  excesoCabida: boolean
  id: number
  idAcuseLexnet: number
  idMensajeCorreccion: number
  intervinientes?: Interviniente[]
  intervinientesFromLexonValidated: boolean
  informarFiscalia: boolean
  orden: Orden | null
  organoDestinoDeTituloJudicial: boolean | null
  organoJudicial: OrganoJudicial | null
  organoOrigenTipo: number | null
  organismoOrigen: OrganismoOrigen | null
  organoOrigen: Origen | null
  organoOrigenJudicial: OrganoJudicial | null
  organoOrigenOrden: Orden | null
  origen: Origen | null
  procedimiento: any
  resolucion: Resolucion
  tipo: TipoEscrito | null
  tipoEscrito: TipoMensaje | null
  tipoMensaje: number
  trasladoCopia: TrasladoCopia[]
}

export interface EstadoEscrito {
  id: number
  descripcion: string
}

export interface EscritoLegal {
  id: number
  descripcion: string
  data: string
  estado: EstadoEscrito
}

export interface ExpedientDataFromLexon {
  nig: string
  proceeding: string
  nig1: string
  nig2: string
  nig3: string
  nig4: string
  nig5: string
  court: string
  interveners: any
  destino: Destino
}
